var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[(_vm.record)?_c('HttpRecordDetail',{attrs:{"record":_vm.record}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }